import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// Layout
import Footer from './layout/Footer';
import Header from './layout/Header';
// Secciones
import Home from './sections/Home';
import Nosotros from './sections/Nosotros';
import Clientes from './sections/Clientes';
import Contacto from './sections/Contacto';
import Proyectos from './sections/Proyectos';
import Error404 from './sections/Error404';
// DataCenter
import HostingEnterprise from './sections/datacenter/HostingEnterprise';
import CloudVps from './sections/datacenter/CloudVps';
import ServidoresDedicados from './sections/datacenter/ServidoresDedicados';
import Housing from './sections/datacenter/Housing';
// Software
import CloudBackup from './sections/software/CloudBackup';
import DesarrolloSoftware from './sections/software/DesarrolloSoftware';
// Servicios TI
import RedesGestionadas from './sections/ti/RedesGestionadas';
import MonitoreoRed from './sections/ti/MonitoreoRed';
import SoporteIntegral from './sections/ti/SoporteIntegral';
import PlataformaWifi from './sections/ti/PlataformaWifi';
// Teleco
import TelefoniaIp from './sections/telecomunicaciones/TelefoniaIp';
import Internet from './sections/telecomunicaciones/Internet';
import EnlaceDatos from './sections/telecomunicaciones/EnlaceDatos';
import CiberSeguridad from './sections/telecomunicaciones/CiberSeguridad';
// Proyectos
import InfraestructuraRed from './sections/proyectos/InfraestructuraRed';
import VigilanciaIp from './sections/proyectos/VigilanciaIp';
import ControlDeAcceso from './sections/proyectos/ControlDeAcceso';

import './assets/css/index.css';
import DetalleProyecto from './sections/DetalleProyecto';

const App = () => {
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <div>
                <Header />
                <Switch>
                    {/* General */}
                    <Route exact path="/" component={Home} />
                    <Route path="/nosotros" component={Nosotros} />
                    <Route exact path="/casos-de-exito" component={Proyectos} />
                    <Route exact path="/proyectos/:slug" component={DetalleProyecto} />
                    <Route path="/clientes" component={Clientes} />
                    <Route path="/contacto" component={Contacto} />

                    {/* datacenter */}
                    <Route path="/servicios/hosting-enterprise" component={HostingEnterprise} />
                    <Route path="/servicios/cloud-vps" component={CloudVps} />
                    <Route path="/servicios/servidores-dedicados" component={ServidoresDedicados} />
                    <Route path="/servicios/housing" component={Housing} />

                    {/* telecomunicaciones */}
                    <Route path="/servicios/internet" component={Internet} />
                    <Route path="/servicios/telefonia-ip" component={TelefoniaIp} />
                    <Route path="/servicios/enlace-datos" component={EnlaceDatos} />
                    <Route path="/servicios/firewall" component={CiberSeguridad} />

                    {/* software */}
                    <Route path="/servicios/cloud-backup" component={CloudBackup} />
                    <Route path="/servicios/desarrollo-software" component={DesarrolloSoftware} />

                    {/* servicios ti */}
                    <Route path="/servicios/redes-gestionadas" component={RedesGestionadas} />
                    <Route path="/servicios/monitoreo-red" component={MonitoreoRed} />
                    <Route path="/servicios/soporte-integral" component={SoporteIntegral} />
                    <Route path="/servicios/plataforma-wifi" component={PlataformaWifi} />

                    {/* proyectos */}
                    <Route path="/servicios/infraestructura-red" component={InfraestructuraRed} />
                    <Route path="/servicios/vigilancia-ip" component={VigilanciaIp} />
                    <Route path="/servicios/control-acceso" component={ControlDeAcceso} />

                    <Route component={Error404} />
                </Switch>
                <Footer />
            </div>
        </Router>
    );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js